import Vue from 'vue'
import tinymce from 'vue-tinymce-editor'

Vue.component('tinymce', tinymce)
